var _defs, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 44.21 49.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 22.64,
    y1: 48.56,
    x2: -9.49,
    y2: 16.43,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 51.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 45.69,
    y1: 26.94,
    x2: -0.64,
    y2: 26.94,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 51.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 28.44,
    y1: 22.55,
    x2: -15.13,
    y2: -21.03,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 51.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -5.12,
    y1: 64.9,
    x2: 14.34,
    y2: 45.44,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 51.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.89.76A3.83,3.83,0,0,0,0,3.45V45.8a3.83,3.83,0,0,0,.89,2.69l.14.13L24.75,24.9v-.56L1,.62Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.65,32.81l-7.9-7.91v-.56l7.91-7.9.17.1,9.37,5.32c2.68,1.52,2.68,4,0,5.53l-9.37,5.32Z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.83,32.71l-8.08-8.09L.89,48.49c.88.93,2.33,1,4,.11l28-15.89",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.83,16.54,4.86.64C3.22-.29,1.77-.17.89.76L24.75,24.62Z",
    fill: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.66,32.53,4.86,48.32c-1.55.89-2.94.83-3.83,0H1l-.14.15h0l.14.13H1c.89.81,2.28.87,3.83,0l28-15.89Z",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.89,48.21A3.83,3.83,0,0,1,0,45.52v.28a3.83,3.83,0,0,0,.89,2.69L1,48.34Z",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2,27.11l-9.54,5.42.17.18,9.37-5.32a3.36,3.36,0,0,0,2-2.77h0A3.55,3.55,0,0,1,42.2,27.11Z",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86.92,42.2,22.14a3.55,3.55,0,0,1,2,2.48h0a3.36,3.36,0,0,0-2-2.76L4.86.64C2.19-.88,0,.39,0,3.45v.28C0,.67,2.19-.6,4.86.92Z",
    fill: "#fff",
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.7bc15287.svg";
export { ForwardRef as ReactComponent };